module.exports = __webpack_public_path__ + "img/Mage-human-f-70.1e69a26f.gif";